// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b49ff194","453":"ece82cfe","455":"3eab91af","486":"18319cc6","616":"202ccb16"}[chunkId] + ".chunk.js";
};